/* Oat-mazing sign-up pop-up (Jenn 2026-10-16: "pop up for signup enjoy RM5 discount").
   The form posts to Shopify's own customer form (/contact, form_type=customer, tagged newsletter), so the email lands in the store's
   customer list with email marketing on. Shopify reloads the page with ?customer_posted=true; the pop-up then shows the code and keeps it
   on this device so oat-checkout.js adds it at checkout. Shown once per visitor after a short delay or a third of the page; closing it
   keeps it closed for 7 days; it never shows again after a sign-up, and never while another dialog is open.
   Nothing shows when the theme setting "Sign-up discount code" is empty. */
(() => {
  const cfg = window.OAT_SHOPIFY || {}, code = (cfg.welcomeCode || '').trim();
  const box = document.querySelector('[data-oat-signup]');
  if (!box || !code) return;
  const SEEN = 'oatmazing:signup-closed-at', DONE = 'oatmazing:welcome-code', WEEK = 7 * 86400000;
  const get = k => { try { return localStorage.getItem(k); } catch { return null; } };
  const set = (k, v) => { try { localStorage.setItem(k, v); } catch { /* storage is optional */ } };
  box.querySelectorAll('[data-welcome-code]').forEach(n => { n.textContent = code; });
  const open = success => {
    box.querySelector('[data-signup-form]').hidden = success;
    box.querySelector('[data-signup-done]').hidden = !success;
    box.hidden = false; document.documentElement.classList.add('oat-signup-open');
    (box.querySelector(success ? '[data-signup-close]' : 'input[type=email]') || box).focus();
  };
  const close = () => { box.hidden = true; document.documentElement.classList.remove('oat-signup-open'); if (!get(DONE)) set(SEEN, String(Date.now())); };
  box.addEventListener('click', e => { if (e.target === box || e.target.closest('[data-signup-close]')) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !box.hidden) close(); });

  if (/[?&]customer_posted=true/.test(location.search)) {          // back from Shopify after a sign-up
    set(DONE, code); open(true);
    history.replaceState(null, '', location.pathname + location.hash.replace(/#oat-signup$/, ''));
    return;
  }
  if (get(DONE) || Date.now() - Number(get(SEEN) || 0) < WEEK) return;
  let armed = true;
  const trigger = () => {
    if (!armed || document.querySelector('dialog[open]')) return;
    armed = false; removeEventListener('scroll', onScroll); open(false);
  };
  const onScroll = () => { const h = document.documentElement.scrollHeight - innerHeight; if (h > 0 && scrollY / h > 0.33) trigger(); };
  addEventListener('scroll', onScroll, {passive: true});
  setTimeout(trigger, Number(cfg.signupDelayMs) || 12000);
})();
